





























































































































































































































































































































































































































































import { Component, Vue, Watch, PropSync } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import LocalizadorEndereco from "./LocalizadorEndereco.vue";
import ConsultaVeiculo from "./ConsultaVeiculo.vue";
import { assistencia24hModule } from "@/store/assistencia24h/Assistencia24h";
import LocalidadeModel from "@/models/geolocalizacao/LocalidadeModel";
import { VeiculoModel } from "@/models/cadastros/assistencia/veiculo/VeiculoModel";
import { TipoServicoEnum } from "@/api/assistencia24h/TipoServicoEnum";
import { QuestionarioGuinchoModel } from "@/models/cadastros/assistencia/guincho/QuestionarioGuinchoModel";
import QuestoesGuincho from "./QuestoesGuincho.vue";
import { QuestoesGuinchoModel } from "@/models/cadastros/assistencia/guincho/QuestoesGuinchoModel";
import { PANE_MECANICA } from "@/models/cadastros/assistencia/guincho/MotivoServicoModel";
import { ValidationObserver } from "vee-validate";
import ContatoLocal from "./ContatoLocal.vue";
import { DadosPagamentoServicoModel } from "@/models/cadastros/assistencia/DadosPagamentoServicoModel";
import ServicoSubClienteModel from "@/models/cadastros/assistencia/ServicoSubClienteModel";
import ServicoSubCliente from "./ServicoSubCliente.vue";
import ClienteAdministrativo from "./ClienteAdministrativo.vue";
import ClienteAdministrativoModel from "@/models/cadastros/assistencia/ClienteAdministrativoModel";
import { tiposEndereco } from "@/models/cadastros/assistencia/TipoEndereco";
import { estadosList } from "@/models/Estados";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import ValoresClienteAdministrativoModel from "@/models/cadastros/assistencia/ValoresClienteAdministrativoModel";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import {PrestadorComplementoModel, PrestadorComplementoConsultaModel} from "@/models/cadastros/assistencia/PrestadorComplementoModel";

@Component({
  components: {
    LocalizadorEndereco,
    ConsultaVeiculo,
    QuestoesGuincho,
    ContatoLocal,
    GsModalDialog,
    ServicoSubCliente,
    ClienteAdministrativo,
  },
  beforeRouteEnter: (to, from, next) => {
    window.scrollTo(0, 0);
    next((vm: any) => {
      const vueComponent = vm as QuestionarioGuincho;
      if (from.name === "ConfirmacaoDadosPrecificacao") {
        vueComponent.loadFromStore();
      } else {
        vueComponent.resetStore();
      }
      assistencia24hModule.SET_TIPO_SERVICO(TipoServicoEnum.GUINCHO);
    });
  },
})
export default class QuestionarioGuincho extends Vue {
  $refs!: {
    guinchoObserver: InstanceType<typeof ValidationObserver>;
  };

  prestadorComplementoSynced!: PrestadorComplementoModel | undefined;
  prestadoresComplementoSynced: PrestadorComplementoModel[] = [];
  loadingClientes = false;
  timerCliente: any = 0;
  dadosPrestadorComplemento: PrestadorComplementoModel = {};
  prestadorComplementoConsultaModel : PrestadorComplementoConsultaModel | undefined;
  textoPesquisaPrestador  = '';
  veiculoDoAssociado = true;
  associadoNoLocal = true;
  nomeContatoNoLocal = "";
  telefoneContatoNoLocal = "";
  questoesGuincho: QuestoesGuinchoModel = {
    possuiRodaTravada: false,
    fotosAcidente: [],
  };

  tiposEnderecos = tiposEndereco;
  estados = estadosList;

  veiculo: VeiculoModel = {
    placa: "",
    chassi: "",
    marca: "",
    modelo: "",
    anoFabricacao: "",
    anoModelo: "",
    cor: "",
    combustivel: "",
    cilindrada: "",
    tipoVeiculo: { valor: "", texto: "" },
  };
  enderecoSelecionado: LocalidadeModel = new LocalidadeModel();
  destinoSelecionado: LocalidadeModel = new LocalidadeModel();
  loadingData = false;
  enderecoServicoFrota: LocalidadeModel = new LocalidadeModel();
  enderecoClienteAdministrativo: LocalidadeModel = new LocalidadeModel();
  messageDialog = false;
  message = "";
  enderecoInvalido = false;
  clienteAdm = false;

  showDialog = false;
  dialogMessage = "";
  dialogType = "success";
  showDialogFrota = false;
  dialogTitle = "";
  dialogMessageAux = "";
  successDialog = false;
  loading = false;
  loadingFrota = false;

  servicoSubClienteFrota: ServicoSubClienteModel = new ServicoSubClienteModel();
  clienteAdministrativo: ClienteAdministrativoModel = new ClienteAdministrativoModel();
  showDialogAdm = false;
  moneyMaskProperties = moneyMaskProperties;
  valoresAdm: ValoresClienteAdministrativoModel = new ValoresClienteAdministrativoModel();
  valoresPrecificado: ValoresClienteAdministrativoModel = new ValoresClienteAdministrativoModel();

  cardForm: DadosPagamentoServicoModel = {
    id: 0,
    bandeira: undefined,
    codigoSeguranca: undefined,
    nomeTitular: undefined,
    numeroCartao: undefined,
    validade: undefined
  };

  tipoEnderecoDes = "";
  tipoEnderecoLoc = "";
  isFrota = false; 
  kmGuinchoContratado = 0;
  precoLabel = "Vl. Total";

  fnCarregaPrestador(valor: PrestadorComplementoModel) {
    this.dadosPrestadorComplemento = {};
    if (valor) {
        valor.descricaoCompleta = valor.cpfCnpj + " - " + valor.nome;
        this.dadosPrestadorComplemento = valor;
    }
  }

  @Watch("dadosPrestadorComplemento.nome")
  obterPrestadoresNome(input: string) {
    let pesquisa = (input || "").trim();

    if (pesquisa == "") {
      this.prestadoresComplementoSynced = [];
      this.prestadorComplementoSynced = undefined;
      this.dadosPrestadorComplemento = {};
      return;
    }
    
    if (
        (
          this.enderecoSelecionado.geoPosicao == undefined 
          && (!this.enderecoSelecionado.latitude || !this.enderecoSelecionado.longitude)
        ) 
        || this.veiculo.tipoVeiculo == undefined 
        || this.veiculo.tipoVeiculo?.valor == ""
      ) {
        this.openDialog(
          "information",
          "Atenção",
          "Preencha todos os dados necessários antes de realizar a busca do prestador."
        );
        return;
      }

    // se o campo tem menos que 3 caracteres não faz a busca
    if (pesquisa.length < 3) return;
    let lat = null;
    let long = null;

    if (!this.enderecoSelecionado.latitude || !this.enderecoSelecionado.longitude) {
      lat = this.enderecoSelecionado.geoPosicao?.latitude;
      long = this.enderecoSelecionado.geoPosicao?.longitude
    } else {
      lat = this.enderecoSelecionado.latitude ;
      long = this.enderecoSelecionado.longitude;
    }

    this.loading = true;
    this.loadingClientes = true;
    this.prestadorComplementoConsultaModel = {};
    this.prestadorComplementoConsultaModel!.latitude = lat;
    this.prestadorComplementoConsultaModel!.longitude = long;
    this.prestadorComplementoConsultaModel!.tipoVeiculo = this.veiculo.tipoVeiculo?.valor;
    this.prestadorComplementoConsultaModel!.tipoServico = "GUINCHO";
    this.prestadorComplementoConsultaModel!.filtroPrestador = pesquisa;

    // Debounce manual - LODASH não funcionou
    clearTimeout(this.timerCliente);
    this.timerCliente = setTimeout(() => {
        ServicosAssistenciaService
        .pesquisarPrestadorComplemento(this.prestadorComplementoConsultaModel)
        .then((clientes: { data: any[] }) => {
          this.prestadoresComplementoSynced = clientes.data.map(valor => {
              valor.descricaoCompleta = valor.cpfCnpj + " - " + valor.nome;
              return Object.assign({}, valor);
          });
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
          this.loadingClientes = false;
        });
    }, 300);
  }

  async atualizaValores() {
    let preco = 0;
    if (!this.valoresAdm.checkboxValorSaida) {
      preco -= this.valoresAdm?.valorSaida || 0;
    } 

    if ((this.valoresAdm?.valorHoraParada || 0) > 0) {
      if ((this.valoresAdm?.qtdHoraParada || 0) == 0) {
        this.valoresAdm.qtdHoraParada = 1;
      }
    }

    if ((this.valoresAdm?.valorHoraTrabalhada || 0) > 0) {
      if ((this.valoresAdm?.qtdHoraTrabalhada || 0) == 0) {
        this.valoresAdm.qtdHoraTrabalhada = 1;
      }
    }

    if ((this.valoresAdm?.valorPatins || 0) > 0) {
      if ((this.valoresAdm?.qtdPatins || 0) == 0) {
        this.valoresAdm.qtdPatins = 1;
      }
    }
    await assistencia24hModule
        .recalcularValorServico({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.valoresAdm.idCliente || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          preco = res;
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.openDialog(
            "error", 
            "Erro ao recalcular serviço", 
            "Tivemos problemas recalcular o valor do serviço. Tente novamente."
            );
        });

        this.valoresAdm.preco = preco
        this.dialogTitle = "Valor da Solicitação " + this.valoresAdm.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
  }

  @Watch("clienteAdministrativo")
  obterDadosClienteAdm(val: any) {
    this.isFrota = false;
    this.kmGuinchoContratado = 0;
    this.clienteAdm = false;
    this.enderecoClienteAdministrativo = new LocalidadeModel();
    if (val.frota) {
      this.isFrota = true;
      this.kmGuinchoContratado = val.kmGuinchoContratado || 0;
    }

    if (val.id) {
      this.clienteAdm = true;
    }

    if (val.endereco) {
      this.enderecoClienteAdministrativo = val.endereco;
      this.enderecoClienteAdministrativo.tipoEndereco = this.tiposEnderecos.find(endereco => endereco.valor === val.endereco.tipo);
      this.enderecoClienteAdministrativo.estado = this.estados.find(estado => estado.sigla === val.endereco.estado);
    }
    
  }

  confirmar() {
    if (this.valoresAdm.frota) {
      this.confirmarFrota();
    } else {
      this.confirmarAdm();
    }
  }

  confirmarAdm() { 
    this.loadingFrota = true;
    assistencia24hModule
        .confirmarSolicitacaoAdm({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.valoresAdm.idCliente || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado
        })
        .then((res: any) => {
          this.closeDialog();
          this.loadingFrota = false;
          this.successDialog = true;
          this.openDialog(
            "success", 
            "Serviço solicitado com sucesso!", 
            "Acompanhe as solicitações através do menu Acompanhar Solicitações."
          );
          this.$router.push({ name: "HomePage" });
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.loadingFrota = false;
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            "Tivemos problemas na solicitação do serviço. Tente novamente."
            );
        });
  }

  confirmarFrota() { 
    this.loadingFrota = true;
    assistencia24hModule
        .confirmarSolicitacaoFrota({
          idServico: assistencia24hModule.precificacao?.idServico || 1,
          idCliente: this.clienteAdministrativo.id || 0,
          idPagamentoCliente: 0,
          numeroParcelas: 0,
          pagamentoCliente: this.cardForm,
          valoresAdministrativo: this.valoresAdm,
          valoresPrecificado: this.valoresPrecificado,
          idPrestador: this.dadosPrestadorComplemento.id || undefined
        })
        .then((res: any) => {
          this.closeDialog();
          this.loadingFrota = false;
          this.successDialog = true;
          this.openDialog(
            "success", 
            "Serviço solicitado com sucesso!", 
            "Acompanhe as solicitações através do menu Acompanhar Solicitações."
          );
          this.$router.push({ name: "HomePage" });
        })
        .catch((err: any) => {
          console.error(err);
          this.closeDialog();
          this.loadingFrota = false;
          this.openDialog(
            "error", 
            "Erro ao solicitar serviço", 
            "Tivemos problemas na solicitação do serviço. Tente novamente."
            );
        });
  }

  @Watch("questoesGuincho.veiculoCarregado")
  questoesGuinchoVeiculoCarregado() {
    if (this.questoesGuincho.veiculoCarregado?.valor == true) {
      this.openDialog(
              "information", 
              "Atenção", 
              "A Seguradora e o Prestador de Serviço não se responsabilizam por danos causados à carga transportada. Se o veículo estiver carregado, o serviço de deslocamento será realizado apenas dentro do município, por razões de segurança."
            );
    }      
  }

  @Watch("veiculoDoAssociado")
  exibeAssociadoNoLocal(val: boolean) {
    if (val) {
      this.associadoNoLocal = true;
    }
  }

  @Watch("associadoNoLocal")
  limpaContato(val: boolean) {
    if (val) {
      this.nomeContatoNoLocal = "";
      this.telefoneContatoNoLocal = "";
    }
  }
  mounted() {
    window.scrollTo(0, 0);
  }

  loadFromStore() {
    this.loadingData = true;
    const questionarioGuincho = assistencia24hModule.questionarioGuincho;
    this.veiculoDoAssociado =
      questionarioGuincho?.veiculoPertenceAoAssociado || true;
    this.veiculo = questionarioGuincho?.veiculo || {
      placa: "",
      chassi: "",
      marca: "",
      modelo: "",
      anoFabricacao: "",
      anoModelo: "",
      cor: "",
      combustivel: "",
      cilindrada: "",
      tipoVeiculo: { valor: "", texto: "" },
    };
    this.enderecoSelecionado =
      questionarioGuincho?.localizacao || new LocalidadeModel();
    this.destinoSelecionado =
      questionarioGuincho?.destino || new LocalidadeModel();
    this.nomeContatoNoLocal = questionarioGuincho?.nomeContatoNoLocal || "";
    this.telefoneContatoNoLocal =
      questionarioGuincho?.telefoneContatoNoLocal || "";
    this.questoesGuincho = {
      motivoSolicitacao: questionarioGuincho?.motivoSolicitacao || undefined,
      parteDanificada: questionarioGuincho?.parteDanificada || undefined,
      descricaoParteDanificada:
        questionarioGuincho?.descricaoParteDanificada || undefined,
      possuiRodaTravada: questionarioGuincho?.rodaTravada || false,
      fotosAcidente: questionarioGuincho?.fotos || [],
    };
    this.servicoSubClienteFrota =
      questionarioGuincho?.servicoSubCliente || new ServicoSubClienteModel();
      this.enderecoServicoFrota.cep = questionarioGuincho?.servicoSubCliente?.cep || "";
    this.clienteAdministrativo =
      questionarioGuincho?.clienteAdministrativo || new ClienteAdministrativoModel();
      this.clienteAdministrativo.endereco!.cep = questionarioGuincho?.clienteAdministrativo?.endereco?.cep || "";  
    this.loadingData = false;
  }

  resetStore() {
    assistencia24hModule.RESET();
  }

  @Watch("veiculoDoAssociado")
  habilitaCamposContato(val: boolean) {
    if (val) {
      this.nomeContatoNoLocal = "";
      this.telefoneContatoNoLocal = "";
    }
  }

  @Watch("enderecoSelecionado.tipoEndereco")
  tipoEnderecoLocalizacao() {
    if (this.enderecoSelecionado.tipoEndereco?.valor == "COMERCIAL") {
      if (this.tipoEnderecoLoc != this.enderecoSelecionado.tipoEndereco?.valor) {
        this.openDialog(
                "information", 
                "Atenção", 
                "Se o endereço escolhido for um endereço comercial. Por favor, verifique o horário de funcionamento do estabelecimento para evitar inconvenientes."
              );
      }    
    }
    this.tipoEnderecoLoc = this.enderecoSelecionado.tipoEndereco?.valor || "";
  }

  @Watch("destinoSelecionado.tipoEndereco")
  tipoEnderecoDestino() {
    if (this.destinoSelecionado.tipoEndereco?.valor == "COMERCIAL") {
      if (this.tipoEnderecoDes != this.destinoSelecionado.tipoEndereco?.valor) {
        this.openDialog(
                "information", 
                "Atenção", 
                "Se o endereço escolhido for um endereço comercial. Por favor, verifique o horário de funcionamento do estabelecimento para evitar inconvenientes."
              );
      }   
    }     
    this.tipoEnderecoDes = this.destinoSelecionado.tipoEndereco?.valor || "";    
  }

  solicitarPrecificacao() { 
    this.$refs.guinchoObserver.validate().then((valid) => {
      this.validarEndereco(this.enderecoSelecionado, this.destinoSelecionado);
      if (this.enderecoInvalido) {
          valid = false;
          this.closeDialog();
          this.openDialog(
            "error", 
            "", 
            "Localização não pode ser igual ao destino."
            );
      }        

      if (!valid) {
        this.openDialog(
          "information", 
          "Dados incompletos", 
          "Preencha todos os campos obrigatórios para continuar com a solicitação do serviço."
        );
        return;
      }

      if (valid) {
        
        if (this.dadosPrestadorComplemento.nome && this.isFrota && !this.dadosPrestadorComplemento.id) {
          this.openDialog(
            "information", 
            "Atenção", 
            "Selecione um prestador válido ou limpe o campo para buscar novamente."
          );
          return;
        }


        this.loading = true;               
        this.messageDialog = false;
        if (this.enderecoServicoFrota) {
          this.servicoSubClienteFrota.cep = this.enderecoServicoFrota.cep;
          this.servicoSubClienteFrota.tipoEndereco = this.enderecoServicoFrota.tipoEndereco; 
          this.servicoSubClienteFrota.logradouro = this.enderecoServicoFrota.logradouro; 
          this.servicoSubClienteFrota.numero = this.enderecoServicoFrota.numero;
          this.servicoSubClienteFrota.complemento = this.enderecoServicoFrota.complemento || ""; 
          this.servicoSubClienteFrota.bairro = this.enderecoServicoFrota.bairro; 
          this.servicoSubClienteFrota.cidade = this.enderecoServicoFrota.cidade; 
          this.servicoSubClienteFrota.estado = this.enderecoServicoFrota.estado; 
        }

        if (this.enderecoClienteAdministrativo) {
          this.clienteAdministrativo.endereco = this.enderecoClienteAdministrativo;
        }
        
        const questionarioGuincho = new QuestionarioGuinchoModel(
          this.veiculoDoAssociado,
          this.questoesGuincho.motivoSolicitacao || PANE_MECANICA,
          this.veiculo,
          this.enderecoSelecionado,
          this.destinoSelecionado,
          this.associadoNoLocal,
          this.nomeContatoNoLocal,
          this.telefoneContatoNoLocal,
          this.questoesGuincho.parteDanificada,
          this.questoesGuincho.descricaoParteDanificada || "",
          this.questoesGuincho.rodaTravada?.valor,
          this.questoesGuincho.fotosAcidente,
          this.servicoSubClienteFrota,
          this.questoesGuincho.tipoLocalRemocao,
          this.questoesGuincho.liberadoRemocao?.valor,
          this.questoesGuincho.veiculoEletrico?.valor,
          this.questoesGuincho.veiculoBlindado?.valor,
          this.questoesGuincho.veiculoCarregado?.valor,
          this.clienteAdministrativo,
          this.dadosPrestadorComplemento?.id
        );

        assistencia24hModule.SET_QUESTIONARIO_GUINCHO(questionarioGuincho);
        assistencia24hModule
          .solicitarPrecificacaoGuincho()
          .then((res: any) => {
            if (assistencia24hModule.precificacao) {
              const precificacao = assistencia24hModule.precificacao as Record<string, any>;
              this.valoresAdm = {
                  valorTotalAdicional: precificacao.valorTotalAdicional ?? 0,
                  valorHoraParada: precificacao.valorHoraParada ?? 0,
                  valorPatins: precificacao.valorPatins ?? 0,
                  valorHoraTrabalhada: precificacao.valorHoraTrabalhada ?? 0,
                  valorPedagio: precificacao.valorPedagio ?? 0,
                  valorPrestador: precificacao.valorPrestador ?? 0,
                  valorGuinchoPesado: precificacao.valorGuinchoPesado ?? 0,
                  valorOperadora: precificacao.valorOperadora ?? 0,
                  valorComissaoCorretor: precificacao.valorComissaoCorretor ?? 0,
                  valorAgravo: precificacao.valorAgravo ?? 0,
                  valorDesconto: precificacao.valorDesconto ?? 0,
                  idCliente: precificacao.idCliente,
                  frota: precificacao.frota ?? false,
                  preco: precificacao?.preco ?? 0,
                  valorSaida: precificacao?.valorSaida ?? 0,
                  valorExcedente: precificacao?.valorExcedente ?? 0,
                  qtdKmExcedente: precificacao?.qtdKmExcedente ?? 0,
                  checkboxValorSaida: true,
                  qtdPatins: 0,
                  qtdHoraTrabalhada: 0,
                  qtdHoraParada: 0,
                  kmTotal: precificacao?.kmTotal?? 0
              };

              this.valoresPrecificado = {
                  valorTotalAdicional: precificacao.valorTotalAdicional ?? 0,
                  valorHoraParada: precificacao.valorHoraParada ?? 0,
                  valorPatins: precificacao.valorPatins ?? 0,
                  valorHoraTrabalhada: precificacao.valorHoraTrabalhada ?? 0,
                  valorPedagio: precificacao.valorPedagio ?? 0,
                  valorPrestador: precificacao.valorPrestador ?? 0,
                  valorGuinchoPesado: precificacao.valorGuinchoPesado ?? 0,
                  valorOperadora: precificacao.valorOperadora ?? 0,
                  valorComissaoCorretor: precificacao.valorComissaoCorretor ?? 0,
                  valorAgravo: precificacao.valorAgravo ?? 0,
                  valorDesconto: precificacao.valorDesconto ?? 0,
                  idCliente: precificacao.idCliente,
                  frota: precificacao.frota ?? false,
                  preco: precificacao?.preco ?? 0,
                  valorSaida: precificacao?.valorSaida ?? 0,
                  valorExcedente: precificacao?.valorExcedente ?? 0,
                  qtdKmExcedente: precificacao?.qtdKmExcedente ?? 0,
                  checkboxValorSaida: true,
                  qtdPatins: 0,
                  qtdHoraTrabalhada: 0,
                  qtdHoraParada: 0,
                  kmTotal: precificacao?.kmTotal?? 0
              };
            };
            if (assistencia24hModule.precificacao?.frota && assistencia24hModule.precificacao?.faturamento) {
              this.closeDialog();
              this.openDialogCliente( 
                "confirm",
                "Valor da Solicitação " + assistencia24hModule.precificacao?.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) ,
                "O Pagamento acontecerá no fechamento da sua fatura com os descontos negociados.",
                "Acompanhe as solicitações através do menu Acompanhar Solicitações."
              );
            } else {
              this.openDialogCliente( 
                "confirm",
                "Valor da Solicitação " + assistencia24hModule.precificacao?.preco.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) ,
                "",
                ""
              );
            }
            this.loading = false;
          })
          .catch((err: any) => {
            this.loading = false;
            console.error(err);
            this.openDialog(
              "information", 
              "Problema ao solicitar serviço", 
              err.message
            );
          });
      }
    });
    this.loading = false;
  }

  validarEndereco(localizacao: LocalidadeModel, destino: LocalidadeModel) {
    if (localizacao.cep == destino.cep &&
        localizacao.logradouro == destino.logradouro &&
        localizacao.numero == destino.numero &&
        localizacao.complemento == destino.complemento &&
        localizacao.bairro == destino.bairro &&
        localizacao.cidade == destino.cidade &&
        localizacao.estado == destino.estado &&
        localizacao.latitude == destino.latitude &&
        localizacao.longitude == destino.longitude) {
        this.enderecoInvalido = true;
    } else {
      this.enderecoInvalido = false;
    }
  }

  fecharMessageDialog() {
    this.messageDialog = false;
    this.message = "";
  }

  closeDialog() {
    this.showDialog = false;
    this.dialogMessage = "";
    this.dialogMessageAux = "";
    this.showDialogFrota = false;
    this.showDialogAdm = false;
    this.loading = false;
    this.loadingFrota = false;
    if (this.successDialog) {
      this.$router.push({ name: "MinhasSolicitacoes" });
    }
    this.successDialog = false;
  }

  private openDialogCliente(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogAdm = true;
  }

  private openDialogFrota(dialogType: string, title: string, message: string, messageAux: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.dialogMessageAux = messageAux;
    this.showDialogFrota = true;
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      case "information":
        text = "Ok, entendi";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      case "information":
        color = "primary";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
